import {
    alphabeticError,
    dateFormatError,
    dateTimeError,
    decimalPlaces2Error,
    decimalPlaces1Error,
    emailError,
    noDecimalsError,
    noSpecialCharacters,
    numericError,
    phoneError,
    yearError,
    zipError,
    freeFormSpecialCharsError
} from "../constants/messages";

export const onlyAlphabetic = /^[A-Za-z '.,-]*$/;
export const onlyNumeric = /^[0-9]*$/;
export const phoneRegex = /^[0-9]{10}$/;
export const zipRegex = /^[0-9]{5}$/;
export const moneyRegex = /^[0-9]*(\.[0-9]{1,2})?$/;
export const emailRegex = /^.+@.+\..+$/;
export const yearRegex = /^[12]{1}[0-9]{3}$/;
export const phoneLength = 10;
export const zipLength = 5;
export const autoEmailRegex = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
export const alpahNumericRegex = new RegExp('^\\w+$');
export const noSpecialsRegex = /^[^\[\]#$%^&<>*`\\]+$/;
export const freeFormRegex = /^([A-Za-z0-9 .,':;/?$%()!"@_\r\n-])*$/;

export const univMinDate = new Date(1900, 0, 1, 1, 1, 1, 1)

export const alphabeticTest = {
    regex: onlyAlphabetic,
    regexMessage: alphabeticError
};
export const phoneTest = {
    regex: phoneRegex,
    regexMessage: phoneError
};
export const zipTest = {
    regex: zipRegex,
    regexMessage: zipError
};
export const emailTest = {
    regex: autoEmailRegex,
    regexMessage: emailError
};
export const dateTimeTest = {
    isDate: true,
    regexMessage: dateTimeError
};
export const dateTest = {
    isDate: true,
    regexMessage: dateFormatError
};
export const yearTest = {
    regex: yearRegex,
    regexMessage: yearError
};
export const numericTest = {
    regex: onlyNumeric,
    regexMessage: numericError
};
export const wholeNumbersTest = {
    regex: onlyNumeric,
    regexMessage: noDecimalsError,
  };
export  const decimalPlacesTest = {
    regex: /^[0-9]{1,2}(\.[0-9])?$/,
    regexMessage: decimalPlaces1Error,
  }; //limits to 2 digits to the left of the decimal, and optional decimal and one digit after the decimal
export const moneyTest = {
    regex: moneyRegex,
    regexMessage: decimalPlaces2Error
};
export const initialTest = {
    regex: /^[A-Za-z]*$/,
    regexMessage: alphabeticError
};
export const noSpecialsTest = {
    regex: noSpecialsRegex,
    regexMessage: noSpecialCharacters,
};
export const freeFormTest = {
    regex: freeFormRegex,
    regexMessage: freeFormSpecialCharsError
};
export const zipProps = {
    minLength: 5,
    maxLength: 5
};
export const phoneProps = {
    minLength: 10,
    maxLength: 10
};
export const yearProps = {
    minLength: 4,
    maxLength: 4
};
export const hoursPerDayProps = {
    min: 0,
    max: 24
};
export const moneyProps = {
    min: 0,
    max: 2100000000
};
export const length1Props = { maxLength: 1 };
export const length5Props = { maxLength: 5 };
export const length50Props = { maxLength: 50 };
export const length40Props = { maxLength: 40 };
export const length100Props = { maxLength: 100 };
export const length200Props = { maxLength: 200 };
export const length500Props = { maxLength: 500 };
export const emailLengthProps = { maxLength: 255 };
export const length1333Props = { maxLength: 1333 };

export const trueFalseRequired = (value) => value === true || value === false;

